// constants
import { DataModelDesignerActionTypes } from './constants';

export interface DataModelDesignerActionType<TPayload> {
    type:
        
    | DataModelDesignerActionTypes.CHANGE_SEARCH_VALUE
    | DataModelDesignerActionTypes.CHANGE_DATAMODELID
    | DataModelDesignerActionTypes.CHANGE_FIELD
    | DataModelDesignerActionTypes.CHANGE_SELECTED_FIELD  
    | DataModelDesignerActionTypes.CHANGE_SHAXES
    | DataModelDesignerActionTypes.CHANGE_SHAXES_REMOVE   
    | DataModelDesignerActionTypes.CHANGE_NEWFIELD    
    | DataModelDesignerActionTypes.CHANGE_ADDNEWFIELD 
    | DataModelDesignerActionTypes.CHANGE_TABALE_POSITION
    | DataModelDesignerActionTypes.CHANGE_EDGES
                
    payload?: TPayload;
}

export const changeSearchValueDatasourceAction = (layout: any): DataModelDesignerActionType<any> => ({
    type: DataModelDesignerActionTypes.CHANGE_SEARCH_VALUE,
    payload: layout,
});

export const changeDataModelIdAction = (layout: any): DataModelDesignerActionType<any> => ({
    type: DataModelDesignerActionTypes.CHANGE_DATAMODELID,
    payload: layout,
});

export const changeFieldDatasourceAction = (layout: any): DataModelDesignerActionType<any> => ({
    type: DataModelDesignerActionTypes.CHANGE_FIELD,
    payload: layout,
});

export const changeSelectedFieldDatasourceAction = (layout: any): DataModelDesignerActionType<any> => ({
    type: DataModelDesignerActionTypes.CHANGE_SELECTED_FIELD,
    payload: layout,
});

export const changeTablePostionAction = (layout: any): DataModelDesignerActionType<any> => ({
    type: DataModelDesignerActionTypes.CHANGE_TABALE_POSITION,
    payload: layout,
});

export const changeShaxesListDatasourceAction = (layout: any): DataModelDesignerActionType<any> => ({
    type: DataModelDesignerActionTypes.CHANGE_SHAXES,
    payload: layout,
});

export const changeShaxesRemoveFromListDatasourceAction = (layout: any): DataModelDesignerActionType<any> => ({
    type: DataModelDesignerActionTypes.CHANGE_SHAXES_REMOVE,
    payload: layout,
});

export const changeNewFieldInDataModelAction = (layout: any): DataModelDesignerActionType<any> => ({
    type: DataModelDesignerActionTypes.CHANGE_NEWFIELD,
    payload: layout,
});

export const changeAddNewFieldInDataModelAction = (layout: any): DataModelDesignerActionType<any> => ({
    type: DataModelDesignerActionTypes.CHANGE_ADDNEWFIELD,
    payload: layout,
});

export const changeEdgeDatasourceAction = (layout: any): DataModelDesignerActionType<any> => ({
    type: DataModelDesignerActionTypes.CHANGE_EDGES,
    payload: layout,
});

